import React from 'react'
import RowWithMenu from '../components/RowWithMenu'

const withRowMenu = Component => ({ rowMenu = [], getTrGroupProps, ...rest }) => {
	return(
		<Component
			{...rest}
			TrGroupComponent={RowWithMenu}
			getTrGroupProps={(state, rowInfo) => {
				const definedProps = getTrGroupProps ? getTrGroupProps(state, rowInfo) : {}
				return {
					...definedProps,
					rowMenu,
					data: rowInfo?.original
				}
			}}
		/>
	)
}

export default withRowMenu

